




import {Component, Prop, Vue} from 'vue-property-decorator'
import DataGrid, {DataType} from '@/components/DataGrid.vue'
import {reformatDate} from "@/data/sources/dates"
import {executeQuery} from "@/data/repos/query"

@Component({
  components: {
    DataGrid,
  },
})
export default class InhouseReactiveJobsAllocatedForMonthToDateGrid extends Vue {
  @Prop() public args!: {
    month: number,
    year: number,
    jobCategory: number,
    status: number,
  }
  public fields = [
    {name: 'Task_Id', title: 'Task id', dataType: DataType.Number, sort: 1},
    {name: 'Reported_Date_Time', title: 'Reported date', dataType: DataType.Date, sort: 1},
    {name: 'Reporter_Name', title: 'Reporter name', dataType: DataType.Text, sort: 1},
    {name: 'Problem_Short_Desc', title: 'Short description', dataType: DataType.Text, sort: 1},
    {name: 'Site_Desc', title: 'Site', dataType: DataType.Text, sort: 1},
    {name: 'Building_Desc', title: 'Building', dataType: DataType.Text, sort: 1},
    {name: 'Status', title: 'Status', dataType: DataType.Text, sort: 1},
    {name: 'Complete_Date', title: 'Completed', dataType: DataType.Date, sort: 1},
  ]
  private currentMonth: number = new Date().getMonth() + 1
  private currentYear: number = new Date().getFullYear()

  public getData(offset: number = 0, limit: number = 250) {

    // @userID int,
    // @month int,
    // @year int,
    // @ppmRepairAll int,
    // @category nvarchar(10),
    // @contractor nvarchar(20),
    // @usecategory int,
    // @status int -- 0-Outstanding, 1-Done, 2-Cancelled, 3-Failed, 4-Supressed

    // GetJobsAllocatedInAMonth/' + locationId + '/1/' + month + '/' + year + '/1/0/' + inhouseContractor + '/0',
    const p = this.args
    return executeQuery("" +
      "FMS_DB",
      "inhouseReactiveJobsAllocatedForMonthToDateGrid",
      {category: p.jobCategory, year: p.year, month: p.month, status: p.status},
      this.filter,
      offset, limit)
  }

  private filter(data: any[]): any {
    const filteredData: any[] = []
    for (const item of data) {
      filteredData.push({
        ...item,
        Reported_Date_Time: reformatDate(item.Reported_Date_Time),
        Complete_Date: reformatDate(item.Complete_Date),
      })
    }
    return filteredData
  }
}
